// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ng-0";